import CohortMenu from "./Filters/CohortMenu";
import AgeMenu from "./Filters/AgeMenu";
import SexMenu from "./Filters/SexMenu";
import InsuranceMenu from "./Filters/InsuranceMenu";
import RegionsMenu from "./Filters/RegionsMenu";
import YearsMenu from "./Filters/YearsMenu";
import React, {SetStateAction} from "react";
import StateMenu from "./Filters/StateMenu";
import useCohortType from "./Stores/CohortStore";
import useAgeType from "./Stores/AgeStore";
import useSexType from "./Stores/SexStore";
import useInsuranceType from "./Stores/InsuranceStore";
import {Dispatch} from "@reduxjs/toolkit";

interface FilterProps {
  displayValue: number;
  map: boolean;
  setCentersCheck?: React.Dispatch<SetStateAction<any>>;
  comparator: string;
}

const Filters: React.FC<FilterProps> = ({
  displayValue,
  map,
  setCentersCheck,
  comparator,
}): JSX.Element => {
  const disabledCohort = useCohortType((state) => state.disabledCohort);
  const disabledAge = useAgeType((state) => state.disabledAge);
  const disabledSex = useSexType((state) => state.disabledSex);
  const disabledInsurance = useInsuranceType(
    (state) => state.disabledInsurance,
  );

  return (
    <section className="bg-valmidnight rounded-xl flex items-stretch justify-center border border-solid border-gray w-full p-2">
      <section className="flex flex-row flex-nowrap items-stretch justify-between w-full px-2">
        {comparator !== "Cohort" ? (
          <section className="flex-1 min-w-0 rounded-3xl bg-valmainheart flex flex-col items-center justify-center text-5xl text-valmidnight font-caption-1 my-4 mx-2">
            <div
              className={`text-inherit font-bold font-inherit ${disabledCohort ? "text-gray-400 opacity-60" : ""}`}>
              Cohort
            </div>
            <CohortMenu displayValue={displayValue} />
            <div className="mt-2" />
          </section>
        ) : null}

        {comparator !== "Age" ? (
          <section className="flex-1 min-w-0 rounded-3xl bg-valmainheart flex flex-col items-center justify-center text-5xl text-valmidnight font-caption-1 my-4 mx-2">
            <div
              className={`text-inherit font-bold font-inherit ${disabledAge ? "text-gray-400 opacity-60" : ""}`}>
              Age
            </div>
            <AgeMenu displayValue={displayValue} />
            <div className="mt-2" />
          </section>
        ) : null}

        {comparator !== "Sex" ? (
          <section className="flex-1 min-w-0 rounded-3xl bg-valmainheart flex flex-col items-center justify-center text-5xl text-valmidnight font-caption-1 my-4 mx-2">
            <div
              className={`text-inherit font-bold font-inherit ${disabledSex ? "text-gray-400 opacity-60" : ""}`}>
              Sex
            </div>
            <SexMenu displayValue={displayValue} />
            <div className="mt-2" />
          </section>
        ) : null}

        {comparator !== "Insurance" ? (
          <section className="flex-1 min-w-0 rounded-3xl bg-valmainheart flex flex-col items-center justify-center text-5xl text-valmidnight font-caption-1 my-4 mx-2">
            <div
              className={`text-inherit font-bold font-inherit ${disabledInsurance ? "text-gray-400 opacity-60" : ""}`}>
              Insurance
            </div>
            <InsuranceMenu displayValue={displayValue} />
            <div className="mt-2" />
          </section>
        ) : null}

        {comparator !== "State" && (
          <section className="flex-1 min-w-0 rounded-3xl bg-valmainheart flex flex-col items-center justify-center text-5xl text-valmidnight font-caption-1 my-4 mx-2">
            <div className="text-inherit font-bold font-inherit">State</div>
            <StateMenu displayValue={displayValue} />
            <div className="mt-2" />
          </section>
        )}

        {/* {map ? (
          <section className="flex-1 min-w-0 rounded-3xl bg-valmainheart flex flex-col items-center justify-center text-5xl text-valmidnight font-caption-1 my-4 mx-2">
            <div className="text-inherit font-bold font-inherit">Region</div>
            <RegionsMenu displayValue={displayValue} />
            <div className="mt-2" />
          </section>
        ) : null} */}

        {comparator !== "Year" ? (
          <section className="flex-1 min-w-0 rounded-3xl bg-valmainheart flex flex-col items-center justify-center text-5xl text-valmidnight font-caption-1 my-4 mx-2">
            <div className="text-inherit font-bold font-inherit">Years</div>
            <YearsMenu displayValue={displayValue} />
            <div className="mt-2" />
          </section>
        ) : null}
      </section>
    </section>
  );
};

export default Filters;
